export const Styles = {
  wrapper: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#ffffff",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    gap: "16px",
  },
  logoImage: {
    maxWidth: "200px",
    height: "auto",
    animation: "fadeIn 0.6s ease-in-out",
  },
  textImage: {
    maxWidth: "300px",
    height: "auto",
    animation: "fadeIn 0.8s ease-in-out",
  },
  loaderWrapper: {
    marginTop: "32px",
    animation: "fadeIn 1s ease-in-out",
  },
  poweredByWrapper: {
    position: "absolute" as const,
    bottom: "40px",
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    gap: "8px",
    animation: "fadeIn 1.2s ease-in-out",
  },
  poweredByImage: {
    height: "30px",
    width: "auto",
  },
};
